export default Object.freeze({
    UNKNOWN  : 'unknown', // has not been checked yet
    OK   : 'ok', // is passed
    PENDING   : 'pending', // failing but not for long enough yet
    FAILING   : 'failing', // is failing
})
